import { useMemo } from 'react';
import { MaterialReactTable } from 'material-react-table';
import Stack from '@mui/material/Stack';
import { Box, Grid } from '@mui/material';
import { FluxButton, FluxCard, FluxEmptyState, FluxWafer, FluxIcon } from '@meltwater/flux-web-components-react';
import JiraSearch from './jiraSearch';
import { round } from '@meltwater/flux-web-components';
import styles from './jira.module.css';
import csvDownload from 'json-to-csv-export'
import { saveAs } from 'file-saver';

const OpportunityTable = ({ transformedData }) => {
  const columns = useMemo(
    () => [

      {
        header: 'key',
        accessorKey: 'key',
        Cell: ({ cell }) => (
          <FluxButton
            tint="primary"
            type="text"
            href={`/jira/${cell.getValue()}`}>{cell.getValue()}</FluxButton>
        ),
      },
      {
        header: 'summary',
        accessorKey: 'summary',
      },
      {
        header: 'assignee_emailAddress',
        accessorKey: 'assignee_emailAddress',
      },
      {
        header: 'priority',
        accessorKey: 'priority',
      },
      {
        header: 'status',
        accessorKey: 'status',
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={(theme) => ({
              backgroundColor:
                (cell.getValue() === "Resolved" || cell.getValue() === "Closed")
                  ? theme.palette.success.light
                  : theme.palette.warning.light,
              borderRadius: '0.25rem',
              color: '#fff',
              maxWidth: '9ch',
              p: '0.25rem',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
            })}
          >
            {cell.getValue()?.toLocaleString?.('en-US', {

            })}
          </Box>
        ),
      },
      {
        header: 'reporter_emailAddress',
        accessorFn: (row) => `${row.reporter_emailAddress}`,
      },
      {
        header: 'Last Update (UTC)',
        accessorKey: 'lastupdate',
        Cell: ({ cell }) => {
          const date = new Date(cell.getValue());
          return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}T${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}:${String(date.getUTCSeconds()).padStart(2, '0')}`;
        }
      },
      {
        header: 'Created (UTC)',
        accessorKey: 'created',
        Cell: ({ cell }) => {
          const date = new Date(cell.getValue());
          return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}T${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}:${String(date.getUTCSeconds()).padStart(2, '0')}`;
        }
      },
    ],
    [],
  );
  
  
  const Opheader = (data) => {
    return (<>
      <div style={{ 'marginLeft': 10 }}>
        <Grid container>
          <Grid marginTop={1} item xs={12} >
            <FluxWafer primaryText={data.companyname} secondaryText={`${data.support_level || ""} Mrr: ${round(data.mrr || 0)} ${data.churned ? '(Churned)' : '(Active)'}`}>
              {data.churned && <FluxIcon name={'general:bolt'} slot='prefix' className={styles.statusfluxicon} bgColor='var(--flux-color-red)'></FluxIcon>}
              {!data.churned && <FluxIcon name={'general:blur'} slot='prefix' className={styles.statusfluxicon} bgColor='var(--flux-color-green)'></FluxIcon>}
            </FluxWafer>
          </Grid>
        </Grid>
      </div>
    </>
    )
  }
  

  function getOneTicket(ticket)
  {
    return( `
    <h2>
    Ticket ${ticket.key} - ${ticket.status}
    </h2>
    <p>
    Ticket Created: ${ticket.created} by ${ticket.reporter_emailAddress} 
    <br/>
    Last Update:  ${ticket.lastupdate} and is currently assigned to ${ticket.assignee_emailAddress}
    </p>
    <h6>Summary</h6>
    <p>
    ${ticket.summary}
    </p>
       
  `);

  }
  const exportToWord = (rows,opportunityname) => {

    const content = `<html>
    <head>
     <style>
     
    p{
      
      text-align: left;
      font-size: 10px;
      word-wrap: break-word; // Added property for vertical growth 
    }
    h2 {
      font-weight: bold;
      font-size: 12px;
      
    }
     </style>
   </head>
   <Body>
   <h2>${opportunityname} Tickets</h2>
   <hr/>
    
   ${rows.map((item) => getOneTicket(item.original)).join('<hr/>')}

   </Body>
   </html>
   `;


    // Add a header and a line break between each item
    // Create a Blob containing the text content
    const blob = new Blob([content], { type: 'application/msword' });

    // Save the Blob as a Word document
    const filename = `MWTR`
    saveAs(blob, filename);
  };

const handleExportRows = ((rows,opportunityname) => {
  
  const exportdata = rows.map((oneitem) => {
    
    return oneitem.original
  }
  )
  
  const data = {
    data: exportdata,
    delimiter: ',',
    filename: `MWTRs for ${opportunityname}`,

  }


  csvDownload(data)
}
)

  const allTickets = useMemo(() => {
    if (!transformedData?.opportunities) return [];
    return transformedData.opportunities.flatMap(opp => (opp.tickets || []).map(ticket => ({...ticket, opportunity: opp})));
  }, [transformedData]);

  // Opportunity summary for header
  const summaryHeader = (
    <Box mb={3}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Box>
              <strong>Total Tickets:</strong> {allTickets.length}
              {allTickets.length === 100 && (
                <span style={{ color: '#e57300', marginLeft: 8, fontWeight: 400, fontSize: '0.95em' }}>
                  (showing the 100 most recent tickets, there may be more)
                </span>
              )}
            </Box>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <JiraSearch />
        </Grid>
      </Grid>
    </Box>
  );

  if (!transformedData?.opportunities || transformedData.opportunities.length === 0) {
    return (
      <div style={{ margin: '20px' }}>
        <FluxCard>
          <FluxEmptyState style={{ minHeight: '400px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div slot="title" style={{ marginBottom: '2rem' }}>No Active Opportunities for the account</div>
            <div slot="actions" style={{ position: 'relative', zIndex: 1 }}>
              <JiraSearch />
            </div>
          </FluxEmptyState>
        </FluxCard>
      </div>
    );
  }

  return (
    <div style={{ margin: '20px' }}>
      <FluxCard style={{ marginBottom: '20px' }}>
        <Opheader data={transformedData} />
      </FluxCard>
      {summaryHeader}
      <MaterialReactTable
        columns={columns}
        data={allTickets}
        density="compact"
        enableStickyHeader
        layoutMode="grid"
        enableColumnFilterModes={true}
        enableGrouping={true}
        enableColumnPinning={true}
        enableFacetedValues={true}
        enableRowSelection={true}
        enableGlobalFilter={true}
        enablePagination={true}
        initialState={{ 
          density: 'compact',  
          pagination: { pageSize: 20, pageIndex: 0 },
          sorting: [{ id: 'lastupdate', desc: true }]
        }}
        muiPaginationProps={{
          color: 'primary',
          shape: 'rounded',
          variant: 'outlined',
        }}
        paginationDisplayMode="pages"
        renderTopToolbarCustomActions={({ table }) => (
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <FluxButton
              tint="primary"
              type="filled"
              onClick={() => handleExportRows(
                table.getPrePaginationRowModel().rows, 
                `opportunities-all`
              )}
            >
              Export All Data
            </FluxButton>
            <FluxButton
              tint="accent"
              type="filled"
              onClick={() => handleExportRows(
                table.getSelectedRowModel().rows, 
                `opportunities-selected`
              )}
              disabled={!table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()}
            >
              Export Selected
            </FluxButton>
            <FluxButton
              tint="accent"
              type="filled"
              onClick={() => exportToWord(
                !table.getIsSomeRowsSelected() 
                  ? table.getPrePaginationRowModel().rows 
                  : table.getSelectedRowModel().rows,
                `opportunities-all`
              )}
            >
              Export Word
            </FluxButton>
          </Box>
        )}
      />
    </div>
  );
};

export default OpportunityTable;
